import { useTranslation } from 'react-i18next';
import { createFileRoute } from '@tanstack/react-router';
import { getPatientQueryOptions } from '@/api/queries/patients';
import { useSuspenseQuery } from '@tanstack/react-query';
import { CueReactivityCharts } from '@/components/cockpit/cueReactivity/cueReactivityCharts';
import { BackButton } from '@/components/ui/backButton';
import { assembleRoute } from '@/types/routes';

export const Route = createFileRoute(
  '/_app/patients/$patientId/procedures/$procedureId/cueing/',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  const { patientId, procedureId } = params;
  const { t } = useTranslation();

  const { data: patient } = useSuspenseQuery(getPatientQueryOptions(patientId));

  return (
    <section className="flex flex-col flex-1 max-w-full">
      <header className="flex flex-col space-y-space-2xs">
        <BackButton linkLabel={ t('routes.patientDetails') } href={ assembleRoute('patientDetails', { patientId }) } />
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-space-lg">
            <h1 className="font-h1">
              { t('procedure.cueReactivity', { ns: 'patients' }) }
            </h1>
          </div>
          <p className="font-normal text-end">
            { patient.subjects?.[0]?.protocol.name }
            <br />
            { `${t('mrn', { ns: 'patients' })}: ${patient.externalId}` }
          </p>
        </div>
      </header>

      <div className="py-space-2xl">
        <CueReactivityCharts procedureId={ procedureId } readonly variant="card" />
      </div>
    </section>
  );
}
